import { useState, useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import AIChatbot from "@/components/AIChatbot";
import LoadingScreen from "@/components/LoadingScreen";
import AnimatedRoutes from "@/components/AnimatedRoutes";

const queryClient = new QueryClient();

const App = () => {
  // Only show loading screen on homepage, instantly show content on other routes
  const isHomepage = window.location.pathname === "/" || window.location.pathname === "";
  const [showContent, setShowContent] = useState(!isHomepage);
  const [showLoadingScreen, setShowLoadingScreen] = useState(isHomepage);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        {showLoadingScreen && (
          <LoadingScreen onComplete={() => setShowContent(true)} />
        )}
        <BrowserRouter>
          <AIChatbot />
          <div className="min-h-screen bg-background text-foreground">
            <div
              className={`transition-opacity duration-700 ease-out ${
                showContent ? "opacity-100" : "opacity-0"
              }`}
            >
              <AnimatedRoutes />
            </div>
          </div>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
